'use client';
import { Box, IconButton, LinearProgress } from '@mui/material';
import { cloneElement, useTransition, ReactElement, useState, useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { MenuContainerProps } from './types';
import styles from './MenuContainer.module.scss';
import { wsSearch } from '@/shared/service/wsSearch/wsSearch';
import { Tooltip } from '@/shared/ui/Tooltip';
export function MenuContainer({
  pathname = '/',
  onClick,
  icon,
  title,
  isExpand,
  expandElement,
  isDisabled
}: MenuContainerProps) {
  const [isPending, startTransition] = useTransition();
  const [idDisabledWS, setIdDisabledWS] = useState(wsSearch.isConnected());
  const router = useRouter();
  const fullPathname = usePathname();

  async function handleSetPathname() {
    if (onClick !== undefined) {
      onClick();
      return;
    }

    if (pathname === fullPathname) return;

    startTransition(() => {
      router.push(pathname);
    });
  }

  useEffect(() => {
    const unsubscribe = wsSearch.subscribe((connected) => {
      setIdDisabledWS(connected);
    });
    return () => unsubscribe();
  }, []);

  return (
    <Tooltip placement="right" title={isDisabled && idDisabledWS ? 'Запущен другой поиск! Переключение не возможно!' :''}>
      <Box
        width={'100%'}
        height={'100%'}
        // height={height}
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        position="relative"
      >
        {isExpand ? (
          <>
            {expandElement}
          </>
        ): (

          <IconButton 
            onClick={() => {handleSetPathname();}}
            type="button"
            disabled={isDisabled && idDisabledWS}
            sx={{
              position: "relative",
              zIndex: 2,
              width: "100%", 
              gap: "8px",
              padding: "8px 8px",
              borderRadius: 0,
              height: "30px",
              display: "flex",
              flexDirection: "row", 
              justifyContent: "start",
              alignItems: "center", 
              backgroundColor: fullPathname.includes(pathname) ? 'transparent' : 'transparent'
            }}
          >
            {cloneElement(icon as ReactElement)}
            {isPending ? (<div style={{ width: '80%', height: '30px', paddingTop: '15px' }}><LinearProgress style={{ color: 'var(--sapphire-20)' }}/></div> ) : (          
              <div className={styles.title} style={{ color: fullPathname.includes(pathname) ? 'var(--sapphire-20)' : 'var(--steel-10)' }}>
                {title}
              </div>
            )}
          </IconButton>
        )}
      </Box>
    </Tooltip>
  );
}
